import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CircularProgress from "@mui/material/CircularProgress"; // Import the loader
import axios from "axios";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DataTable from "examples/Tables/DataTable";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import dayjs from 'dayjs';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import DownloadIcon from "@mui/icons-material/Download";
import { FormControl, InputLabel, Select, MenuItem, Snackbar } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";

function SignUpUserList() {
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false); // Modal state
  const [loading, setLoading] = useState(true); // Loader state
  const [selectedUser, setSelectedUser] = useState(null); // User to edit
  const [deleteBox, setdeleteBox] = useState(false); // Modal state
  const [deleteuserId, setdeleteuserId] = useState(""); // Modal state
  const [searchTerm, setSearchTerm] = useState(""); // Search term state
  const [roleFilter, setRoleFilter] = useState(""); // Filter by Created By
  const [creatorNames, setCreatorNames] = useState([]);

  const currentUserRole = localStorage.getItem("userRole"); // Cache role for reuse

  const [formData, setFormData] = useState({
    email: "",
    fullName: "", // Use fullName for sign-up; map to 'name' for business
    companyName: "",
    howDidYouHearAboutUs: "",
    forWhom: "",
    forWhomOtherText: "",
    mobileNumber: "",
    updated_at: '',
    updated_by: '',
  });

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [SnackbarMsg, setSnackbarMsg] = useState("");

  // Consolidated fetch logic based on role
  const fetchData = async () => {
    setLoading(true);
    try {
      const sessionToken = localStorage.getItem("sessionToken");
      if (!sessionToken) {
        console.error("Session token not found. Please log in again.");
        return;
      }

      let response;
      let userColumns;
      let userRows = [];
      let uniqueCreators = [];

      if (currentUserRole === 'BUSINESS_TEAM') {
        const userId = localStorage.getItem("ueserId"); // Fix typo: ueserId -> userId
        response = await axios.get(`https://api.exampladmedia.com/auth/getUsers/${userId}`, {
          headers: { Authorization: sessionToken },
        });

        userColumns = [
          { Header: "Sr. No.", accessor: "srNo", align: "center" },
          { Header: "Email", accessor: "email", align: "center" },
          { Header: "Name", accessor: "name", align: "center" },
          { Header: "Margin", accessor: "margin", align: "center" },
          { Header: "Created By", accessor: "created_by", align: "center" },
          { Header: "Created At", accessor: "created_at", align: "center" },
          { Header: "Created By Name", accessor: "createdByName", align: "center" },
          { Header: "Updated By", accessor: "updated_by", align: "center" },
          // { Header: "Updated At", accessor: "updated_at", align: "center" },
          { Header: "Updated By Name", accessor: "updatedByName", align: "center" },
          { Header: "Last Login ", accessor: "lastLogin", align: "center" },
          { Header: "User Role", accessor: "userRole", align: "center" },
          { Header: "Actions", accessor: "actions", align: "center" },
        ];

        userRows = response.data
          .filter((user) => user.userRole !== "SUPER_ADMIN")
          .map((user, index) => ({
            srNo: index + 1,
            email: user.email,
            name: user.name,
            margin: user.margin || "-",
            created_by: user.created_by || "-",
            created_at: user.created_at ? dayjs(user.created_at).format("DD-MMM-YYYY HH:mm:ss") : "-",
            createdByName: user.createdByName,
            updated_by: user.updated_by || "-",
            updated_at: user.updated_at ? dayjs(user.updated_at).format("DD-MMM-YYYY HH:mm:ss") : "-",
            updatedByName: user.updatedByName,
            lastLogin: user.lastLogin ? dayjs(user.lastLogin).format("DD-MMM-YYYY HH:mm:ss") : "-",
            userRole: user.userRole,
            actions: (
              <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                <EditIcon
                  style={{
                    color: "green",
                    cursor: "pointer",
                    display: (currentUserRole === "SUPER_ADMIN" || currentUserRole === "BUSINESS_TEAM") ? "inline-block" : "none",
                  }}
                  onClick={() => handleEdit(user)}
                />
                <DeleteIcon
                  style={{
                    color: "red",
                    cursor: "pointer",
                    display: currentUserRole === "SUPER_ADMIN" ? "inline-block" : "none",
                  }}
                  onClick={() => handleConfirmDelete(user.userId)}
                />
              </div>
            ),
          }));
      } else {
        response = await axios.get("https://api.exampladmedia.com/api/request/getAllEntries", {
          headers: { Authorization: sessionToken },
        });

        userColumns = [
          { Header: "Sr. No.", accessor: "srNo", align: "center" },
          { Header: "Full Name", accessor: "fullName", align: "center" },
          { Header: "Email", accessor: "email", align: "center" },
          { Header: "Mobile Number", accessor: "mobileNumber", align: "center" },
          { Header: "Company Name", accessor: "companyName", align: "center" },
          { Header: "How Did You Hear About Us", accessor: "howDidYouHearAboutUs", align: "center" },
          { Header: "For Whom", accessor: "forWhom", align: "center" },
          { Header: "For Whom Other Text", accessor: "forWhomOtherText", align: "center" },
          { Header: "Created At", accessor: "createdAt", align: "center" },
          // { Header: "Updated At", accessor: "updatedAt", align: "center" },
          { Header: "Actions", accessor: "actions", align: "center" },
        ];

        userRows = response.data
          .filter((user) => user.userRole !== "SUPER_ADMIN")
          .map((user, index) => ({
            srNo: index + 1,
            email: user.email,
            fullName: user.fullName,
            companyName: user.companyName,
            howDidYouHearAboutUs: user.howDidYouHearAboutUs,
            forWhom: user.forWhom,
            forWhomOtherText: user.forWhomOtherText,
            mobileNumber: user.mobileNumber || "-",
            createdAt: user.createdAt ? dayjs(user.createdAt).format("DD-MMM-YYYY HH:mm:ss") : "-",
            updatedAt: user.updatedAt ? dayjs(user.updatedAt).format("DD-MMM-YYYY HH:mm:ss") : "-",
            actions: (
              <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                <EditIcon
                  style={{
                    color: "green",
                    cursor: "pointer",
                    display: currentUserRole === "SUPER_ADMIN" ? "inline-block" : "none",
                  }}
                  onClick={() => handleEdit(user)}
                />
                <DeleteIcon
                  style={{
                    color: "red",
                    cursor: "pointer",
                    display: currentUserRole === "SUPER_ADMIN" ? "inline-block" : "none",
                  }}
                  onClick={() => handleConfirmDelete(user.id)}
                />
              </div>
            ),
          }));
      }

      setColumns(userColumns);
      setRows(userRows);
      uniqueCreators = [...new Set(response.data.map((user) => user.createdByName).filter(Boolean))];
      setCreatorNames(uniqueCreators);
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(); // Single fetch call based on role
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleEdit = (user) => {
    setSelectedUser(user);
    // Role-aware field mapping
    const baseData = {
      email: user.email,
      updated_at: new Date().toISOString(),
      updated_by: localStorage.getItem("userId") || localStorage.getItem("userRole"), // Use ID or role as fallback
    };

    if (currentUserRole === 'BUSINESS_TEAM') {
      // Business users: map 'name' to 'fullName' for dialog consistency
      setFormData({
        ...baseData,
        fullName: user.name || "", // Map name -> fullName
        mobileNumber: user.mobileNumber || "",
        // Add other business-specific fields if needed (e.g., margin)
      });
    } else {
      // Sign-up users
      setFormData({
        ...baseData,
        fullName: user.fullName || "",
        mobileNumber: user.mobileNumber || "",
        companyName: user.companyName || "",
        howDidYouHearAboutUs: user.howDidYouHearAboutUs || "",
        forWhom: user.forWhom || "",
        forWhomOtherText: user.forWhomOtherText || "",
      });
    }
    setOpen(true);
  };

  const handleConfirmDelete = (userId) => {
    setdeleteuserId(userId);
    setdeleteBox(true);
  };

  const handleDelete = async () => {
    try {
      const sessionToken = localStorage.getItem("sessionToken");
      if (!sessionToken) {
        console.error("Session token not found. Please log in again.");
        return;
      }

      let response;
      if (currentUserRole === 'BUSINESS_TEAM') {
        response = await axios.delete(`https://api.exampladmedia.com/api/request/removeEntries/${deleteuserId}`, {
          headers: { Authorization: sessionToken },
        });
      } else {
        response = await axios.delete(`https://api.exampladmedia.com/api/request/removeEntries/${deleteuserId}`, { // Assume delete endpoint exists
          headers: { Authorization: sessionToken },
        });
      }

      if (response.status === 204) {
        setSnackbarMsg("user deleted successfully");
        setOpenSnackbar(true);
        setTimeout(() => setOpenSnackbar(false), 2000);
        setdeleteBox(false);
        fetchData();
      }
    } catch (error) {
      setSnackbarMsg(error.response?.data?.message || "An error occurred. Please try again.");
      setOpenSnackbar(true);
      setTimeout(() => setOpenSnackbar(false), 2000);
    }
  };

  const handleSave = async () => {
    try {
      const sessionToken = localStorage.getItem("sessionToken");
      if (!sessionToken) {
        setSnackbarMsg("Session expired. Please login again.");
        setOpenSnackbar(true);
        return;
      }

      let response;

      if (currentUserRole === "BUSINESS_TEAM") {
        // BUSINESS TEAM UPDATE
        response = await axios.put(
          `https://api.exampladmedia.com/api/request/editEntries/${selectedUser.userId}`,
          {
            ...formData,
            name: formData.fullName, // map fullName → name
          },
          {
            headers: { Authorization: sessionToken },
          }
        );
      } else {
        // SIGN-UP USER UPDATE
        response = await axios.put(
          `https://api.exampladmedia.com/api/request/editEntries/${selectedUser.id}`,
          formData,
          {
            headers: { Authorization: sessionToken },
          }
        );
      }

      // ✅ SUCCESS HANDLING
      if (response.status === 200) {
        setSnackbarMsg(
          response.data?.message || "User details updated successfully"
        );
        setOpenSnackbar(true);

        setTimeout(() => {
          setOpenSnackbar(false);
        }, 2000);

        setOpen(false);      // close edit dialog
        fetchData();         // refresh table
      }
    } catch (error) {
      // ❌ ERROR HANDLING
      setSnackbarMsg(
        error.response?.data?.message || "Failed to update user. Please try again."
      );
      setOpenSnackbar(true);

      setTimeout(() => {
        setOpenSnackbar(false);
      }, 2000);
    }
  };


  const handleDownloadExcel = () => {
    const exportData = filteredRows.map((row) => {
      const { actions, ...rest } = row;
      return rest;
    });

    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Users");
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    saveAs(new Blob([wbout], { type: "application/octet-stream" }), "SignUpList.xlsx");
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDeleteCancel = () => {
    setdeleteBox(false);
  };

  const [fromDate, setFromDate] = useState("");
  const filteredRows = rows.filter((row) => {
    const matchesSearch =
      (row.name?.toLowerCase() || row.fullName?.toLowerCase() || "").includes(searchTerm.toLowerCase()) ||
      (row.email?.toLowerCase() || "").includes(searchTerm.toLowerCase()) ||
      (row.createdByName?.toLowerCase() || "").includes(searchTerm.toLowerCase());

    const matchesCreator =
      roleFilter === "" ||
      roleFilter === "ALL" ||
      (row.createdByName?.toLowerCase() || "").includes(roleFilter.toLowerCase()) ||
      (row.updatedByName?.toLowerCase() || "").includes(roleFilter.toLowerCase());

    const createdAt = (row.created_at || row.createdAt) !== "-" ? dayjs(row.created_at || row.createdAt) : null;
    const isOnSelectedDate = fromDate
      ? createdAt &&
      createdAt.isAfter(dayjs(fromDate).startOf('day').subtract(1, 'ms')) &&
      createdAt.isBefore(dayjs(fromDate).endOf('day').add(1, 'ms'))
      : true;

    return matchesSearch && matchesCreator && isOnSelectedDate;
  });

  return (
    <DashboardLayout>
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <h2 style={{ color: "white", margin: 0 }}>Sign Up Form List</h2>

                {currentUserRole === "SUPER_ADMIN" && (
                  <>
                    {/* <MDBox sx={{ background: "white", borderRadius: "8px" }}>
                      <FormControl
                        variant="outlined"
                        sx={{
                          width: 220,
                          backgroundColor: "white",
                          borderRadius: "8px",
                          boxShadow: 1,
                          '& .MuiOutlinedInput-root': {
                            height: 48,
                            borderRadius: '8px',
                            backgroundColor: 'white',
                          },
                          '& .MuiInputLabel-root': {
                            fontSize: '14px',
                            top: '-4px',
                            backgroundColor: 'white',
                            padding: '0 4px',
                          },
                          '& .MuiSelect-select': {
                            padding: '14px',
                            fontSize: '14px',
                            backgroundColor: 'white',
                          },
                        }}
                      >
                        <InputLabel id="created-by-label">Created by - updated by</InputLabel>
                        <Select
                          labelId="created-by-label"
                          value={roleFilter}
                          onChange={(e) => setRoleFilter(e.target.value)}
                          label="Created By"
                        >
                          <MenuItem value="ALL">All</MenuItem>
                          {creatorNames.map((name) => (
                            <MenuItem key={name} value={name}>{name}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </MDBox> */}
                    <TextField
                      type="date"
                      label="Created Date"
                      InputLabelProps={{
                        shrink: true,
                        sx: {
                          color: "#000",          // black
                          fontWeight: 900,        // ✅ bold title
                          fontSize: "13px",       // optional (looks cleaner)
                        },
                      }}
                      value={fromDate}
                      onChange={(e) => setFromDate(e.target.value)}
                      sx={{
                        backgroundColor: "#fff",
                        borderRadius: "4px",
                        mr: 1,

                        // keep label black even on focus
                        "& .MuiInputLabel-root": {
                          color: "#000",
                          fontWeight: 900,
                        },
                        "& .MuiInputLabel-root.Mui-focused": {
                          color: "#000",
                          fontWeight: 900,
                        },
                      }}
                    />


                  </>
                )}
                <TextField
                  variant="outlined"
                  placeholder="Search by name..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  style={{ backgroundColor: "white", borderRadius: "4px", width: "300px" }}
                />
                <Tooltip title="Download Sign Up List">
                  <Button
                    variant="outlined"
                    onClick={handleDownloadExcel}
                    style={{
                      backgroundColor: "white",
                      color: "grey",
                      border: "1px solid #49a3f1",
                      marginLeft: "20px",
                      marginTop: "-7px",
                    }}
                  >
                    <DownloadIcon />
                  </Button>
                </Tooltip>
              </MDBox>

              <MDBox pt={3}>
                {loading ? (
                  <MDBox
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    height="300px"
                  >
                    <CircularProgress color="info" />
                  </MDBox>
                ) : (
                  <DataTable
                    table={{ columns, rows: filteredRows }}
                    isSorted={false}
                    entriesPerPage={true}
                    showTotalEntries={true}
                    noEndBorder
                  />
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Edit User</DialogTitle>
        <DialogContent>
          <TextField
            label="Full Name"
            name="fullName"  // Fixed: Matches formData.fullName
            value={formData.fullName}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />

          <TextField
            label="Mobile no"
            name="mobileNumber"  // Fixed: Matches formData.mobileNumber
            value={formData.mobileNumber}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />

          <TextField
            label="Company Name"
            name="companyName"  // Fixed: Matches formData.companyName
            value={formData.companyName}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />

          <TextField
            label="How Did You Hear About Us"
            name="howDidYouHearAboutUs"  // Fixed: Matches formData.howDidYouHearAboutUs
            value={formData.howDidYouHearAboutUs}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />

          <TextField
            label="For Whom"
            name="forWhom"  // Fixed: Matches formData.forWhom
            value={formData.forWhom}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />

          <TextField
            label="For Whom Other Text"
            name="forWhomOtherText"  // Fixed: Matches formData.forWhomOtherText
            value={formData.forWhomOtherText}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />

          <TextField
            label="Email"
            name="email"  // Already correct
            value={formData.email}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleSave} style={{ color: "green" }}>
            Save
          </Button>
          <Button onClick={handleClose} style={{ color: "red" }}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={openSnackbar}
        message={SnackbarMsg}
        autoHideDuration={2000}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        onClose={() => setOpenSnackbar(false)}
      />
      <Dialog open={deleteBox} onClose={handleDeleteCancel}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <p>Are you sure you want to delete this user?</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDelete} style={{ color: "green" }}>
            Confirm
          </Button>
          <Button onClick={handleDeleteCancel} style={{ color: "red" }}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
}

export default SignUpUserList;